// Vendor imports
const PropTypes = require('prop-types')
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const morePropTypes = require('client-v2/common/utils/prop-types')
const { ARTICLE_HAS_MIX_CHANGE_PENDING } = require('client-v2/common/models/article/actions')

const bem = BemEntity('ArticleMixButton')

function ArticleMixButton(props) {
  const { checked } = props
  const [ didMix, setDidMix ] = React.useState(false)
  const onClick = React.useCallback(
    event => {
      props.onClick(event)
      setDidMix(checked === false)
    },
    [ checked, props.onClick, setDidMix ]
  )
  const onMouseLeave = React.useCallback(
    () => setDidMix(false),
    [ setDidMix ]
  )
  const blockModifiers = getBlockModifiers(checked, didMix)
  const hoverTipText = getHoverTipText(checked)
  return (
    tag('button', {
      ref: props.forwardedRef,
      className: classNames(
        props.className,
        'Button', // Inherit hover styles from base Button
        bem.block(blockModifiers)
      ),
      title: hoverTipText,
      onClick,
      onMouseLeave
    },
      tag('div', {
        className: bem.element('icon')
      }),
      tag('label', {
        className: bem.element('label')
      },
        checked ? 'Mixed' : 'Mix'
      ),
      tag(ArticleMixButtonHoverTip, {
        checked
      })
    )
  )
}

ArticleMixButton.propTypes = {
  // Values
  className: PropTypes.string,
  checked: PropTypes.oneOf([
    true,
    false,
    ARTICLE_HAS_MIX_CHANGE_PENDING
  ]),
  forwardedRef: morePropTypes.domRef,
  // Callbacks
  onClick: PropTypes.func
}

module.exports = ArticleMixButton

function ArticleMixButtonHoverTip(props) {
  const text = getHoverTipText(props.checked)
  if (!text) {
    return null
  }
  return (
    tag('div', {
      className: bem.element('hover-tip')
    },
      text
    )
  )
}

function getBlockModifiers(checked, didMix) {
  return {
    checked: checked === true,
    unchecked: checked === false,
    pending: checked === ARTICLE_HAS_MIX_CHANGE_PENDING,
    'show-label': checked === true && didMix
  }
}

function getHoverTipText(checked) {
  if (checked === true) {
    return 'Add to a collection'
  }
  if (checked === false) {
    return 'Click to Mix the things you like'
  }
}
